import styled from "@emotion/styled";

import { SubHeaderLevels } from "./SubHeaderTypes";

export const Subheader = styled.h1<{ level: SubHeaderLevels; color: string }>(
    {
        // NOTE Это значения из User agent стилей -- reset.css не должен менять эти отступы
        marginBlockStart: "0.83em",
        marginBlockEnd: "0.83em",
    },
    props => ({
        fontWeight: "bold",
        // @ts-ignore
        color: props.theme.candy.typography.subheader.color[props.color],
    }),
    props =>
        props.level === SubHeaderLevels.Level1 && {
            fontSize: "18px",
            lineHeight: "24px",
        },
    props =>
        props.level === SubHeaderLevels.Level2 && {
            fontSize: "16px",
            lineHeight: "22px",
        },
    props =>
        props.level === SubHeaderLevels.Level3 && {
            fontSize: "14px",
            lineHeight: "18px",
        },
    props =>
        props.level === SubHeaderLevels.Deprecated && {
            fontSize: "16px",
            lineHeight: "22px",
        }
);
